import { c as _c } from "react/compiler-runtime";
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { CommitmentAvatarTooltip } from '../../atoms/commitment-avatar-tooltip/commitment-avatar-tooltip.tsx';
import { CommitmentAvatar, CommitmentAvatarProps } from '../../atoms/commitment-avatar/commitment-avatar.tsx';
interface CommitmentAvatarGroupProps {
  commitments: GraphQLCommitment[];
  layout?: 'spaced' | 'stacked';
  itemsToShow?: number;
  purpose?: CommitmentAvatarProps['purpose'];
  size?: CommitmentAvatarProps['size'];
  tooltipMessage?: string;
  usePortal?: boolean;
}
export const CommitmentAvatarGroup = t0 => {
  const $ = _c(23);
  const {
    commitments,
    layout: t1,
    itemsToShow: t2,
    purpose,
    size,
    tooltipMessage,
    usePortal: t3
  } = t0;
  const layout = t1 === undefined ? "stacked" : t1;
  const itemsToShow = t2 === undefined ? 3 : t2;
  const usePortal = t3 === undefined ? true : t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== commitments || $[1] !== itemsToShow || $[2] !== layout || $[3] !== purpose || $[4] !== size) {
    const items = commitments.slice(0, itemsToShow);
    const t7 = layout === "spaced";
    const t8 = layout === "stacked";
    if ($[8] !== t7 || $[9] !== t8) {
      t6 = cn({
        "flex flex-row gap-comfy-xs": t7,
        "flex items-center gap-snug-md": t8
      });
      $[8] = t7;
      $[9] = t8;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    const t9 = layout === "spaced";
    if ($[11] !== t9) {
      t4 = cn("flex flex-row", {
        "gap-snug-xl": t9
      });
      $[11] = t9;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t5 = items.map((commitment, index) => {
      const shouldShowRemaining = index === itemsToShow - 1 && commitments.length > itemsToShow;
      const remainingCount = commitments.length - itemsToShow + 1;
      return <CommitmentAvatar key={commitment.internalId} {...!shouldShowRemaining ? {
        commitment
      } : {
        text: `+${remainingCount}`
      }} size={size} isStacked={index < items.length - 1 && layout === "stacked"} purpose={purpose} />;
    });
    $[0] = commitments;
    $[1] = itemsToShow;
    $[2] = layout;
    $[3] = purpose;
    $[4] = size;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5) {
    t7 = <div className={t4}>{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== tooltipMessage || $[17] !== usePortal) {
    t8 = tooltipMessage && <CommitmentAvatarTooltip translation={tooltipMessage} usePortal={usePortal} />;
    $[16] = tooltipMessage;
    $[17] = usePortal;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};